import React from 'react';
import { IconButton } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { StepperContainer, StepperLabel } from './styles';
import { StepperProps } from './types';

export function Stepper({
  steps,
  step,
  next,
  previous,
  disabledNext = false,
}: StepperProps) {
  return (
    <StepperContainer>
      <IconButton
        size="small"
        color="primary"
        onClick={previous}
        disabled={step === 0}
        aria-label="Previous step"
      >
        <ArrowBackIosIcon fontSize="small" />
      </IconButton>
      <StepperLabel variant="body2">
        {`${step + 1} OF ${steps.length}`}
      </StepperLabel>
      <IconButton
        size="small"
        color="primary"
        onClick={next}
        disabled={step === steps.length - 1 || disabledNext}
        aria-label="Next step"
      >
        <ArrowForwardIosIcon fontSize="small" />
      </IconButton>
    </StepperContainer>
  );
}
